module.exports = __webpack_public_path__ + "img/quick_tutorial_icon.90efb4b8.png";